
import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";
import {
  SaleTaxTable,
  SaleTax as SaleTaxType,
} from "@/types/system-setting/sale-tax";

export const SalesTax = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getSalesTax: builder.query<
        SaleTaxTable,
        {
          query: string;
          org_id: number;
        }
      >({
        query: (searchCretiria) => ({
          url: `/sale_taxes?${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax","IncomeCategory", "Memberships"],
      }),
      createSalesTax: builder.mutation<ApiResponse, SaleTaxType>({
        query: (saleTaxesdata) => ({
          url: `/sale_taxes`,
          method: "POST",
          body: saleTaxesdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      updateSalesTax: builder.mutation<ApiResponse, SaleTaxType>({
        query: (saleTaxesdata) => ({
          url: `/sale_taxes/${saleTaxesdata.id}`,
          method: "PUT",
          body: saleTaxesdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      deleteSalesTax: builder.mutation<ApiResponse, number>({
        query: (sale_tax_id) => ({
          url: `/sale_taxes/${sale_tax_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      getSalesTaxById: builder.query<SaleTaxType, number>({
        query: (sale_tax_id) => ({
          url: `/sale_taxes/${sale_tax_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      getSalesTaxList: builder.query<
        {
          id: number;
          name: string;
          percentage: number;
        }[],
        number
      >({
        query: (org_id) => ({
          url: `/sale_taxes/list/`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
    };
  },
});

export const {
  useGetSalesTaxQuery,
  useCreateSalesTaxMutation,
  useUpdateSalesTaxMutation,
  useDeleteSalesTaxMutation,
  useGetSalesTaxByIdQuery,
  useGetSalesTaxListQuery,
} = SalesTax;
